<template>
  <div class="modal-overlay">
    <div class="modal-content">
      <div class="modal-header">
        <h3>{{ enrollment ? 'Edit Enrollment' : 'Add Student to Course' }}</h3>
        <button @click="$emit('close')" class="close-button">×</button>
      </div>
      
      <div class="form-group">
        <label>Student</label>
        <select v-model="form.student_id" :disabled="!!enrollment">
          <option v-for="student in availableStudents" 
                  :value="student.student_id"
                  :key="student.student_id">
            {{ student.name }} (ID: {{ student.student_id }})
          </option>
        </select>
      </div>

      <div class="form-group">
        <label>Status</label>
        <input type="text" v-model="form.status" placeholder="Enrollment status">
      </div>

      <div class="modal-footer">
        <button @click="$emit('close')">Cancel</button>
        <button @click="save" class="save-button">Save</button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, watch } from 'vue';
import { useMutation } from '@vue/apollo-composable';
import { CREATE_STUDENT_COURSE, UPDATE_STUDENT_COURSE } from '../graphql/queries';

const props = defineProps({
  courseId: Number,
  enrollment: Object,
  availableStudents: Array
});

const emit = defineEmits(['save', 'close']);

const form = ref({
  student_id: null,
  status: ''
});

watch(() => props.enrollment, (newVal) => {
  if (newVal) {
    form.value = {
      student_id: newVal.student_id,
      status: newVal.status || ''
    }
  } else {
    form.value = {
      student_id: props.availableStudents[0]?.student_id || null,
      status: ''
    }
  }
}, { immediate: true });

const { mutate: createStudentCourse } = useMutation(CREATE_STUDENT_COURSE);
const { mutate: updateStudentCourse } = useMutation(UPDATE_STUDENT_COURSE);

const save = () => {
  const input = {
    course_id: props.courseId,
    student_id: form.value.student_id,
    status: form.value.status || null
  };
  if (props.enrollment) {
    updateStudentCourse( input ).then(() => emit('save'));
  } else {
    createStudentCourse( input ).then(() => emit('save'));
  }
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0,0,0,0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  background: white;
  padding: 2rem;
  border-radius: 8px;
  width: 500px;
  max-width: 90%;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
}

.close-button {
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
}

.form-group {
  margin-bottom: 1rem;
}

.form-group label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: bold;
}

.form-group select,
.form-group input {
  width: 100%;
  padding: 0.5rem;
  border: 1px solid #ddd;
  border-radius: 4px;
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
  margin-top: 1.5rem;
}

.save-button {
  background-color: #4CAF50;
  color: white;
}

.save-button:hover {
  background-color: #45a049;
}
</style>